<template>
<md-card>
    <header-form title="GERAR MENSALIDADE" :btnHide="true" />

    <form @submit.prevent="create">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-30 md-xsmall-size-100">
                    <md-datepicker v-model="dados.data" md-immediately v-mask="'##/##/####'">
                        <label>Data Inicial</label>
                    </md-datepicker>
                </div>
            </div>
        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-success md-round">
                <span class="md-label">
                    <md-icon class="material-icons">sync</md-icon>
                </span>GERAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'
import preLoader from '@/config/mixins/preLoader';

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {},
            errors: {}
        }
    },
    mixins: [Notify, preLoader],
    methods: {
        create() {
            let loader = this.openLoader();
            this.$http.post(this.$urlAPI + 'mensalidades', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        }
    }
};
</script>
